/** Sınıf adlarını birleştirir; yanlış/boş değerler atılır. */
export function cn(...parts) {
    return parts.filter(Boolean).join(' ');
}
//# sourceMappingURL=cn.js.map